import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CarrierResdit7421PerformanceReport from '../../components/CarrierResdit7421PerformanceReport';
import {
  COLUMN_ACCESSOR_CARDIT_TOTAL,
  PROPERTY_ORIGINAL_GRAND_TOTAL,
  getFilteredAndSortedData,
  getGeneratedOnDateTime,
  getIsLoading,
  getIsFiltered,
  getOriginalGrandTotal, getColumns,
} from '../redux/selectors/CarrierResdit7421PerformanceLocationSelectors';
import CarrierResdit7421PerformanceLocationReportMode from './CarrierResdit7421PerformanceLocationReportMode';
import {
  getLeafColumns, getPropertyValueByPath, setPropertyValueByPath, deepClone,
} from '../../../../../react-table/helpers/utils';
import { getReportMode } from '../../../../common/redux/selectors/ReportsSelectors';
import {
  changeReportFiltering,
  changeReportMode,
  changeReportSorting,
} from '../../../../common/redux/actions/ReportsActions';

const MODE_TABS = [
  { value: CarrierResdit7421PerformanceLocationReportMode.percentage, label: '%' },
  { value: CarrierResdit7421PerformanceLocationReportMode.number, label: '#' },
];

class CarrierResdit7421PerformanceLocationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillUnmount() {
    this.props.changeReportFiltering({
      reportDefinition: {
        id: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id,
      },
      sorting: {},
      filtering: {},
    });
  }

  onLocationReportSortedChange = (newSorted, column, shiftKey) => {
    this.props.changeReportSorting({
      reportDefinition: {
        id: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id,
      },
      sorting: {
        newSorted,
        column,
        shiftKey,
      },
    });
  };

  onLocationReportFilteredChange = (column, value) => {
    this.props.changeReportFiltering({
      reportDefinition: {
        id: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id,
      },
      filtering: {
        appliedFilters: column,
        appliedColumn: value,
      },
    });
  };

  getColumnsWithOriginalGrandTotal() {
    const { columns } = this.props;

    const transformedColumns = deepClone(columns);

    const leafColumns = getLeafColumns(transformedColumns);
    const columnWithGrandTotalLink = leafColumns.find(column => column.accessor === COLUMN_ACCESSOR_CARDIT_TOTAL);

    const originalGrandTotal = getPropertyValueByPath(columnWithGrandTotalLink, PROPERTY_ORIGINAL_GRAND_TOTAL);
    if (!originalGrandTotal && this.props.isFiltered && this.props.originalGrandTotal) {
      setPropertyValueByPath(columnWithGrandTotalLink, PROPERTY_ORIGINAL_GRAND_TOTAL, this.props.originalGrandTotal);
    }

    return transformedColumns;
  }

  changeMode = (reportMode) => {
    this.props.changeReportMode({
      reportDefinition: {
        id: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id,
      },
      reportMode,
    });
  };

  render() {
    return (<CarrierResdit7421PerformanceReport
      reportId={ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id}
      columns={this.getColumnsWithOriginalGrandTotal.apply(this)}
      isLoading={this.props.isLoading}
      generatedOnDateTime={this.props.generatedDateTime}
      data={this.props.data}
      modeTabs={MODE_TABS}
      changeMode={this.changeMode}
      mode={this.props.mode}
      onSortedChange={this.onLocationReportSortedChange}
      onFilteredChange={this.onLocationReportFilteredChange}
    />);
  }
}

function mapStateToProps(state) {
  return {
    data: getFilteredAndSortedData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
    mode: getReportMode(state, ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id),
    isFiltered: getIsFiltered(state),
    originalGrandTotal: getOriginalGrandTotal.apply(this, [state]),
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    changeReportMode,
    changeReportSorting,
    changeReportFiltering,
  }, dispatch);

CarrierResdit7421PerformanceLocationContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
  changeReportFiltering: PropTypes.func,
  changeReportSorting: PropTypes.func,
  changeReportMode: PropTypes.func,
  isFiltered: PropTypes.bool,
  originalGrandTotal: PropTypes.number,
  mode: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(CarrierResdit7421PerformanceLocationContainer);
